// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2heL9","label":"Section_label__3gSKk","contentWrap":"Section_contentWrap__1q00v","footer":"Section_footer__1siry","footerInner":"Section_footerInner__1I2Rr"};